import { useRef } from 'react'
import { connect } from 'react-redux'
import toJS from '../../../containers/general/toJS.js';
import getData from '../../../functions/getData';
import { TRANSLATION } from '../../../constants/state';
import EditEventFormTypeWrapper from './EditEventFormTypeWrapper';
import TranslationTime from '../../Translation/cont/TranslationTime';
import EditEventFormTime from './EditEventFormTime'
import EditField from '../general/EditField';
import getTranslationTime from '../../Translation/func/getTranslationTime.js';
import EditEventFormDatePicker from './EditEventFormDatePicker.jsx';
import getTranslationStringById from '../../Translation/func/getTranslationStringById';

const mapStateToProps = (state) => ({
    timezone: getData(state, [TRANSLATION, 'timezone']),
    currentLang: getData(state, [TRANSLATION, 'currentLang']),
    locale: getData(state, [TRANSLATION, 'locale']),
    debug: getData(state, [TRANSLATION, 'debug']),
    translationStrings: getData(state, [TRANSLATION, 'strings'])
})

const EditEventFormDateTime = ({ headline, values, formData, formSettings, timezone, activeField, currentLang, debug, locale, setActiveField, setFieldValue, translationStrings}) => {
    const inputRefStart = useRef(null)
    const inputRefEnd = useRef(null)
    const { event_time_start, event_time_end } = values

    const formatValue = (value, formatId="time") => value ? getTranslationTime(formatId, timezone, currentLang, value, debug) : ''

    let timeOutput = '';

    if (formSettings.time_types.order.length > 0) {
        const timeItem = formSettings.time_types.items[formData.time_types]
        timeOutput = timeItem.time_type_name;

        if (timeItem.time_type_start && timeItem.time_type_end)
            timeOutput += (` (zwischen ${timeItem.time_type_start} Uhr und ${timeItem.time_type_end} Uhr)`);
        else if (timeItem.time_type_start && !timeItem.time_type_end)
            timeOutput += (` (ab ${timeItem.time_type_start} Uhr)`)
        else if (!timeItem.time_type_start && timeItem.time_type_end)
            timeOutput += (` (bis ${timeItem.time_type_end} Uhr)`);
    }

    return (
        <EditEventFormTypeWrapper headline={headline}>
            <div className='date-and-time'>
                <div className='edit-event-date-field'>
                <EditField
                    label='Datum'
                    name="date.date"
                    withLineBreak={true}
                    formValue={formatValue(formData.date.date, 'dateWithDay')}
                    currValue={formatValue(values.date.date, 'dateWithDay')}
                    activeField={activeField}
                    setActiveField={setActiveField}
                >
                    <EditEventFormDatePicker
                        name="date"
                        values={values}
                        pickerType="date"
                        dateTypes={formSettings.date_types}
                        timezone={timezone}
                        currentLang={currentLang}
                        locale={locale}
                        debug={debug}
                        setActiveField={setActiveField}
                        setFieldValue={setFieldValue}

                    />
                </EditField>
                </div>

                {timeOutput && <p className='time-display text-small-light'>
                    <span>{'Uhrzeit:'}</span>
                    <br />
                    <span>{timeOutput}</span>
                </p>}

                <div className='start-end-time'>
                    <EditField
                        label={ getTranslationStringById('event_detail_start', translationStrings, currentLang, 'Start') }
                        name="event_time_start"
                        lineBreakInCurrentName={false}
                        formValue={formatValue(formData.event_time_start)}
                        currValue={formatValue(event_time_start)}
                        inputRef={inputRefStart}
                        activeField={activeField}
                        setActiveField={setActiveField}
                    >
                        <EditEventFormTime
                            name="event_time_start"
                            date={values.date.date}
                            value={event_time_start}
                            inputRef={inputRefStart}
                            timezone={timezone}
                            currentLang={currentLang}
                            debug={debug}
                        />

                    </EditField>

                    <EditField
                        label={ getTranslationStringById('event_detail_end', translationStrings, currentLang, 'End') }
                        name="event_time_end"
                        lineBreakInCurrentName={false}
                        formValue={formatValue(formData.event_time_end)}
                        currValue={formatValue(event_time_end)}
                        inputRef={inputRefEnd}
                        activeField={activeField}
                        setActiveField={setActiveField}
                    >
                        <EditEventFormTime
                            name="event_time_end"
                            date={values.date.date}
                            value={event_time_end}
                            inputRef={inputRefEnd}
                            timezone={timezone}
                            currentLang={currentLang}
                            debug={debug}
                        />

                    </EditField>
                </div>

            </div>
        </EditEventFormTypeWrapper>
    );
}

export default connect(mapStateToProps, null)(toJS(EditEventFormDateTime))